import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Icon } from "antd";
//Simport TitleHome from "../../../components/Admin/Home/TitleHome";
//import Courses from "../../../components/Admin/Home/Courses";
//import Promotions from "../../../components/Admin/Home/Promotions";
//import TypeChart from "../../../components/Admin/Home/TypeChart";
import RequestChart from "../../../components/Admin/Home/RequestChart";
import RequestObs from "../../../components/Admin/Home/RequestObs";
import RequestStatus from "../../../components/Admin/Home/RequestStatus";
import RequestCourses from "../../../components/Admin/Home/RequestCourses";
import RequestAcreditacion from "../../../components/Admin/Home/RequestAcreditacion";
import "./HomeAdmin.scss";
import { getEstadisticasHome } from "../../../api/estadisticas";
import { withRouter } from "react-router-dom";
//import RequestSinProceso from "../../../components/Admin/Home/RequestSinProceso";
import moment from "moment";

const HomeAdmin = (props) => {
  const {
    proceso: { proceso, estado, distrito },
  } = props;
  //const [process, setProcess] = useState({});
  const isMounted = useRef(true); //Referencia que permite verificar si el componente esta visible
  const [datos, setDatos] = useState({});

  //useEffect que valida que el componente este seleccionado de lo contrario cancela cualquier subcripción
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  //useEffect que valida que el componente este seleccionado de lo contrario cancela cualquier subcripción
  useEffect(() => {
    let idProceso, idDetalle, idEstado, idDistrito;
    if (proceso) {
      idProceso = proceso.idProcesoElectoral;
      idDetalle = proceso.idDetalleProceso;
      idEstado = estado ? estado.idEstado : 0;
      idDistrito = distrito ? distrito.idDistrito : 0;
      /* isMounted.current &&
        setProcess({ idProceso, idDetalle, idEstado, idDistrito }); */
      isMounted.current && getEstadisticasHome(idProceso, idDetalle, idEstado, idDistrito).then((res) => {
        setDatos(res.data.estadisticaHome);
      }).catch((e) => {
        console.log("Error al obtener las estadísticas del Home", e);
      });
    } else if(proceso === null) { //Se valida que sea nulo ya que es cuando realmente no se selecciona proceso y asi evitar ir
      //por las estadisticas cuando sea undefined el proceso
      getEstadisticasHome().then((res) => {
        setDatos(res.data.estadisticaHome);
      }).catch((e) => {
        console.log("Error al obtener las estadísticas del Home", e);
      });
    }
  }, [proceso, estado, distrito]);

  //Obtenemos los datos de la estadistica del portal
  /* useEffect(() => {
    console.log("useEffect de estadisticas");
    //console.log(process);
    getEstadisticasHome(process).then((res) => {
      setDatos(res.data.estadisticaHome);
      console.log("getEstadisticas");
      //console.log(res.data.estadisticaHome);
    });
  }, [process]); */

  const UltimaActualizacion = () => {
    const fechaHora = new Date();
    moment.locale("es");
    const fecha = moment(fechaHora).format("DD/MMMM/YYYY");
    const hora = moment(fechaHora).format("HH:mm:ss");
    return (
        <div style={{ fontSize:"12px", position:"absolute", marginTop:"20px", right:"0" }}>
            <Icon type="calendar" /> {fecha} <Icon type="clock-circle" /> {hora}
        </div>
    );
  }

  return (
    <div>
      <Row>
        <Col span={24}>
          <div style={{ float:"right", fontWeight:"bold", fontSize:"12px" }}>
            Última actualización
          </div>
          <UltimaActualizacion />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <RequestObs conteo={datos.observadores} />
        </Col>
        <Col span={12}>
          <RequestStatus conteo={datos.solRevisar} />
        </Col>
        {/* <Col span={8}>
          <RequestSinProceso conteo={datos.solSinProceso} />
        </Col> */}
      </Row>
      <Row>
        <RequestAcreditacion
          ciudadanos={datos.ciudadanos}
          organizaciones={datos.organizaciones}
          acreditados={datos.acreditados}
        />
      </Row>
      <Row>
        <RequestCourses
          inscritos={datos.inscritosCursos}
          registrados={datos.cursosPre}
          cursosImpartidos={datos.cursosImpartidos}
          personasCapacitadas={datos.personasCapacitadas}
        />
      </Row>
      <Row>
        <h4>Demografía de las solicitudes</h4>
        <RequestChart grafica={datos.grafica} />
      </Row>
    </div>
  );
};

export default withRouter(HomeAdmin);
